module.exports = __webpack_public_path__ + "img/ring_y_i_null_1.28dc2362.png";